module.exports = __webpack_public_path__ + "static/img/partner3.e5c2e48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner3.png
// module id = te4x
// module chunks = 8